import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import type {Lang} from "./language";
import {DEFAULT_LANG, SUPPORTED_LANGS} from "./language";
import {publicResources} from "./public/resources.public";

export const NS_PUBLIC = "public";
export const NS_PROJECT = "project";

export function initI18n(initialLang: Lang) {
    if (i18n.isInitialized) return i18n;

    i18n
        .use(initReactI18next)
        .init({
            lng: initialLang,
            fallbackLng: DEFAULT_LANG,
            supportedLngs: SUPPORTED_LANGS,
            resources: publicResources as any,

            ns: [NS_PROJECT, NS_PUBLIC],
            defaultNS: NS_PROJECT,
            fallbackNS: NS_PUBLIC,

            keySeparator: false,
            nsSeparator: false,

            returnEmptyString: false,

            interpolation: {escapeValue: false},
            react: {useSuspense: false},
        }).then(r => console.log("i18n initialized", r));

    return i18n;
}

export {i18n};
